// extracted by mini-css-extract-plugin
export var compactFilters = "_gv-4";
export var detailImage = "_gv-1";
export var dropdownContainer = "_gv-2";
export var imageContainer = "_gv-0";
export var selectedCard = "_gv-3";